<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="rvh">Praise for <i>The Good Place</i></p>
<p class="rvf">“Holy forking shirtballs, Erin Giannini has written the definitive guide to <i>The Good Place</i>! With a thoughtful eye for detail, Giannini weaves an understanding of the thematic, political, narratological, and pedagogical value of this groundbreaking sitcom. A must-read for fans and scholars alike, this volume explores what <i>The Good Place</i> is, what it can be, and what it means for all of us.”</p>
<p class="rvt">—Paul Booth, professor of media and cinema studies, DePaul University</p>
<p class="rvf">“In addition to her excellent observations on <i>The Good Place</i>’s pointed comedic critique, its deft storytelling techniques, and its engagement with deeper themes, Giannini insightfully examines the place of the series among its televised forebears, contemporaries, and descendants. <i>The Good Place</i> is a good read!”</p>
<p class="rvt">—Janet Brennan Croft, editor of <i>Mythlore: A Journal of J.R.R. Tolkien, C.S. Lewis, Charles Williams, and Mythopoeic Literature</i></p>
<p class="rvf">“This excellent study provides a sophisticated account of the ambitions of <i>The Good Place</i>. Erin Giannini guides us through the complexities of the show both as a sitcom and as pedagogy, assisting us in appreciating both its philosophical themes and its achievement as television. Anyone interested in the show or the possibilities of television would benefit from reading this book.”</p>
<p class="rvt">—James B. South, professor of philosophy, Marquette University</p>
<p class="rvf">“<i>The Good Place</i> provides a thorough and commanding televisual critique worthy of the complexity of its subject matter. Erin Giannini grounds her scholarship in well-explicated political and philosophical context, helping the reader to appreciate both the series’ immediate social relevance and its value as art that transcends its cultural moment. Excellent reading for scholars, students, and fans.”</p>
<p class="rvt">—Regina Hansen, Boston University</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-tvmgoodplace-0002.vue?3d2909e8